/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waitlist_DescriptionInputs */

const en_waitlist_description = /** @type {(inputs: Waitlist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the waitlist for early access and updates`)
};

const es_waitlist_description = /** @type {(inputs: Waitlist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unete a la lista de espera para acceso temprano y novedades`)
};

/**
* | output |
* | --- |
* | "Join the waitlist for early access and updates" |
*
* @param {Waitlist_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const waitlist_description = /** @type {((inputs?: Waitlist_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waitlist_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_waitlist_description(inputs)
	return es_waitlist_description(inputs)
});